import './globals.css';
import '@/styles/fonts/MyFontsWebfontsKit.css';
import type {AppProps} from 'next/app';
import HeaderNavigation from '@/ui/header-navigation/HeaderNavigation';
import Footer from '@/ui/footer/Footer';
import ThemeRegistry from '@/styles/ThemeRegistry';
import "react-image-gallery/styles/css/image-gallery.css";
import "react-photo-album/columns.css";
import "yet-another-react-lightbox/styles.css";
import "react-photo-album/rows.css";
import Script from 'next/script';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {DefaultSeo} from 'next-seo';
import SEO from "@/content/seo/next-seo.config";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { initGsapAnimations } from '@/lib/animations/gsapInit';

const GA_MEASUREMENT_ID = 'G-4CS0XGYJPG';

export default function MyApp({Component, pageProps}: AppProps) {
    const router = useRouter();

    useEffect(() => {
        const handleRouteChange = (url: string) => {
            if (window.gtag) {
                window.gtag('config', GA_MEASUREMENT_ID, {
                    page_path: url,
                });
            }
        };
        router.events.on('routeChangeComplete', handleRouteChange);
        return () => router.events.off('routeChangeComplete', handleRouteChange);
    }, [router.events]);

    useEffect(() => {
        let cleanup: (() => void) | undefined;

        const handleRouteChange = async () => {
            if (cleanup) cleanup(); // Cleanup previous animations
            cleanup = await initGsapAnimations(); // Await the cleanup function
        };

        // Initialize animations on the first load
        handleRouteChange();

        // Reinitialize animations on route change
        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
            if (cleanup) cleanup(); // Cleanup on unmount
        };
    }, [router.events]);

    return (
        <ThemeRegistry>
            {/* Google Analytics Scripts */}
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
                strategy="afterInteractive"
            />
            <Script id="gtag-init" strategy="afterInteractive">
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            page_path: window.location.pathname,
          });
        `}
            </Script>

            <HeaderNavigation/>
            <main>
                <DefaultSeo {...SEO} />
                <Component {...pageProps} />
            </main>
            <Footer/>
        </ThemeRegistry>
    );
}
